import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import DataAnalysis2Form from "./DataAnalysis2Form";

export default function DataAnalysis2Dialog(props) {
    
    const handleClose = () => {
        props.handleCloseDialog()
    }

    const handleCancel = () => {
        props.handleCancelDialog()
    }

    const incompleteStepsExist = (programId) => {
        if (!props.step6CompletionData[programId] ||
            !props.step6CompletionData[programId].completed) {
            return true
        }
        if (!props.step5CompletionData[programId] ||
            !props.step5CompletionData[programId].completed) {
            return true
        }
        if (!props.step4CompletionData[programId] ||
            !props.step4CompletionData[programId].completed) {
            return true
        }
        if (!props.step3CompletionData[programId] ||
            !props.step3CompletionData[programId].completed) {
            return true
        }
        if (!props.step2CompletionData[programId] ||
            !props.step2CompletionData[programId].completed) {
            return true
        }
        if (!props.step1CompletionData[programId] ||
            !props.step1CompletionData[programId].completed) {
            return true
        }
        return false
    }

    const isFormDisabled = (programId) => {
        if (incompleteStepsExist(programId)) {
            return true
        }

        if (programId) {
            // If this step(tab) complete?
            if ((programId in props.stepCompletionData) && 
                props.stepCompletionData[programId]?.completed) {
                return true
            }
        }
        return false
    }

    return (
        <Modal size="lg" show={props.showModal} onHide={handleCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Data Analysis - Edit</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="text-center">
                    <h2>Data Analysis - Round 2</h2>
                    <div className="p-3">
                        <p style={{"textIndent":"50px"}}>
                        Summarize the data collected in the second round of assessment 
                        and share them with the faculty in the program/department. How do 
                        these results compare with the first round of results analyzed in 
                        <span className="fw-bold"> Step 4</span>? Do they support your hypotheses or not? Can any conclusions 
                        be drawn from these two rounds of data collection? Share the faculty's 
                        interpretations here, along with any follow-up questions or next 
                        steps proposed. Information on this dialog box is reported for each 
                        assessed learning outcome and for each program. On the next part of 
                        <span className="fw-bold"> Step 7</span>, more global conclusions will be requested for each program. 
                        Review background information about this step for more information: <a href="https://rise.articulate.com/share/rPhb9SpPhYGQlOeAvErCFjujKFq2VvqX" target="_blank">View</a>
                        </p>
                    </div>
                    { incompleteStepsExist(props.selectedProgram?.programId)
                        ? <div className="pb-3">
                            <span className="text-danger">Previous step(s) must be completed before this step can be completed.</span>
                          </div>
                        : <></>
                    }
                </div>
                <div className="mx-5">
                    <DataAnalysis2Form 
                        department={props.department}
                        selectedProgram={props.selectedProgram}
                        selectedLearningOutcome={props.selectedLearningOutcome}
                        learningOutcomes={props.learningOutcomes}
                        stepData={props.stepData}
                        theme={props.theme}
                        sloQuestions={props.sloQuestions}
                        step1DataStore={props.step1DataStore}
                        step2DataStore={props.step2DataStore}
                        step4DataStore={props.step4DataStore}
                        step5Tab1DataStore={props.step5Tab1DataStore}
                        step5Tab2DataStore={props.step5Tab2DataStore}
                        step1CompletionData={props.step1CompletionData}
                        step2CompletionData={props.step2CompletionData}
                        step3CompletionData={props.step3CompletionData}
                        step4CompletionData={props.step4CompletionData}
                        step5CompletionData={props.step5CompletionData}
                        step6CompletionData={props.step6CompletionData}
                        stepCompletionData={props.stepCompletionData}
                        formDisabled={isFormDisabled(props.selectedProgram?.programId)}
                        handleLearningOutcomeChanged={props.handleLearningOutcomeChanged}
                        handleS7Q1Changed={props.handleS7Q1Changed}
                        handleS7Q2Changed={props.handleS7Q2Changed}
                        handleS7Q3Changed={props.handleS7Q3Changed}
                        />
                </div>
            </Modal.Body>

            <Modal.Footer style={{ display: "flex", justifyContent: "center"}}>
                <Button
                    variant="secondary"
                    onClick={handleCancel}
                    className="p-25"
                    >
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={handleClose}
                    className="p-25"
                    >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}